<template lang="pug">
  section.herocomp
    .hero(:class="{single, 'type-text': tipo == 'text', 'type-video': tipo == 'video'}")
      .hero-wrapper(v-if="!single || (single && tipo == 'text')")
        .hero-figure
          h1
            small {{beneathtitle}}
            | {{titulo}}
            small {{bajada}}
          .play(v-if="tipo === 'video' && !single")
            span.icon-wrap
              font-awesome-icon.icon(:icon="['fa', 'play']")
            | Ver Video
          .play(v-if="tipo === 'text' && !single")
            span.icon-wrap
              font-awesome-icon.icon(:icon="['fa', 'play']")
            | Ver Artículo
      .hero-image(v-if="tipo == 'text'")
        img(:src="imagen", :alt="titulo")
      .hero-featuredvideo(v-if="tipo == 'video' && featuredvideo")
        .video
          video(:src="featuredvideo" muted autoplay loop playsinline)
      .hero-videohtml(v-if="tipo == 'video' && videohtml")
        router-link.wrap-back(:to="{name: 'home'}")
          .play.back
            span.icon-wrap
              font-awesome-icon.icon(:icon="['fa', 'angle-double-left']")
            | Volver
        .video-html(v-html="videohtml")
      Sharer(:title="titulo", :description="bajada", :img="imagen", :slug="slug")
    .video-title(v-if="single && tipo == 'video'")
      h1 {{titulo}}
        small {{bajada}}

</template>

<script>
import Sharer from '@/components/Sharer'
export default {
  name: 'hero',
  components: {
    Sharer
  },
  props: {
    titulo: {
      type: String,
      default: 'Título'
    },
    bajada: {
      type: String,
      default: 'Bajada'
    },
    beneathtitle: String,
    imagen: String,
    featuredvideo: String,
    videohtml: String,
    slug: String,
    tipo: {
      type: String,
      default: 'text'
    },
    single: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">

  .hero {
    height: 100vh;
    overflow: hidden;
    position: relative;
    background-color: black;
    @media (max-width: 800px){
      min-height: 60vh;
    }
    &.type-text{
      .play{
        max-width: 250px;
      }
    }
    .play{
      color: white;
      display: flex;
      font-family: 'Open Sans', sans-serif;
      padding: 1rem;
      font-size: 25px;
      cursor: pointer;
      text-align: center;
      position: relative;
      align-items: center;
      max-width: 220px;
      margin-top: 2rem;
      &:after{
        content: '';
        border: 2px solid white;
        position: absolute;
        left: 0;
        width: 68px;
        height: 68px;
        top: 0;
        border-radius: 50px;
        transition: all .3s;
      }
      &.back{
        margin-left: auto;
        margin-right: auto;
        font-size: 26px;
        padding: 0.9rem 0.6rem 0.9rem 0.9rem;
        max-width: 190px;
        @media (max-width: 800px){
          padding: 0.6rem 0.4rem;
          max-width: 120px;
          font-size: 16px;
          &:after{
            width: 44px;
            height: 44px;
          }
        }
      }
      .icon-wrap{
        width: 34px;
        margin-right: 24px;
        margin-left: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .icon{
        padding: 0;
      }
      &:hover{
        &:after{
          width: 102%;
        }
      }
      @media screen and (max-width: 700px){
        font-size: 21px;
        line-height: 25px;
        .icon-wrap{
          width: 24px;
          margin-right: 24px;
          margin-left: 4px;
        }
        &:after{
          width: 58px;
          height: 58px;
        }
      }
    }
    &.single{
      height: 100vh;
      &.type-video{
        @media (max-width: 800px){
          min-height: 0;
          height: auto;
        }
      }
      .video-html{
        iframe,
        video{
          top: 0;
          bottom: 0;
        }
      }
    }
  }
  .hero-wrapper{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .video-title{
    max-width: 80%;
    text-align: center;
  }
  .hero-figure{
    max-width: 50%;
    text-align: left;
    padding: 0 2rem;
    @media (max-width: 800px){
      max-width: 90%;
      padding: 0 1rem;
    }
  }
  .hero-image{
    opacity: 0.7;
    position: absolute;
    img{
      width: 100vw;
      height: 100vh;
      object-fit: cover;
    }
  }
  .single{
    .hero-image{
      position: fixed;
    }
  }

  .herocomp{
    h1{
      color: white;
      @include fluid-type(360px, 1640px, 30px, 50px);
      small {
        display: block;
        @include fluid-type(360px, 1640px, 16px, 24px);
        line-height: 150%;
        margin-top: 1rem;
      }
    }
    .video-title{
      margin: 3rem auto 0;
      h1{
        color: black;
      }
    }
  }

  .hero{
    .hero-videohtml{
      display: flex;
      align-items: stretch;
      justify-content: center;
      a{
        position: absolute;
        bottom: 7%;
        width: auto;
        z-index: 3;
        opacity: 0.3;
        padding: 0;
        &:hover{
          opacity: 1;
        }
        .play{
          margin-top: 0;
        }
      }
    }
    .hero-featuredvideo{
      display: flex;
      align-items: stretch;
      justify-content: center;
    }
    .video{
      width: 100%;
      height: 100vh;
      position: relative;
      background-color: black;
      &:before{
        content: '';
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url(../assets/grid.png);
        position: absolute;
        z-index: 2;
      }
    }
    .video-html{
      position: relative;
      padding-top: 56.25%;
      padding-bottom: 0;
      height: 0;
      width: 100%;
      background-color: black;
    }
    .video,
    .video-html{
      iframe{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
      }
      video{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        object-fit: cover;
        // border: 1px solid #f0f;
      }
    }
  }
</style>